import { createFileRoute } from '@tanstack/react-router';
import { StudentsView } from '@/components/StudentsView';

export const Route = createFileRoute('/_authenticated/students')({
  component: StudentsView,
});

